import { TicketOfficeView } from '../../../types/ticket-office';
import { CustomerSectionProps } from '../../components/CustomerSection';

export const getCustomerSection = (view: TicketOfficeView): CustomerSectionProps => {
    const { state, update } = view;
    const { lang, customer } = state;

    const props: CustomerSectionProps = {
        sendEmail: {
            label: lang.customer.sendEmail,
            checked: state.sendEmail,
            onChange: (checked): void => {
                state.sendEmail = checked;
                update();
            },
        },
        name: {
            id: 'customer_name',
            label: lang.customer.name,
            value: customer.name,
            onChange: (value): void => {
                customer.name = value;
                update();
            },
        },
        email: {
            id: 'customer_email',
            label: lang.customer.email,
            value: customer.email,
            onChange: (value): void => {
                customer.email = value;
                update();
            },
        },
        phone: {
            id: 'customer_phone',
            label: lang.customer.phone,
            value: customer.phone,
            onChange: (value): void => {
                customer.phone = value;
                update();
            },
        },
        internalNote: {
            id: 'customer_internal_note',
            label: lang.customer.internalNote,
            rows: 5,
            maxLength: 1000,
            value: customer.internalNote ?? '',
            onChange: (value): void => {
                customer.internalNote = value;
                update();
            },
        },
    };

    return props;
};
